import React from 'react';
import UnmatchedTransactionsList from '../features/transactions/UnmatchedTransactionsList';
import PageHeader from '../components/PageHeader';

const DashboardPage: React.FC<{ 
    refresh: boolean;
    onAssign: () => void;
    startDate: string | null;
    endDate: string | null;
    schoolYear: { id: number; name: string; };
}> = ({ refresh, onAssign, startDate, endDate, schoolYear }) => {
    return (
        <div className="page">
            <PageHeader title="Panel" />
            <UnmatchedTransactionsList refresh={refresh} onAssign={onAssign} />
        </div>
    );
};

export default DashboardPage;
